import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { dashboardQKeys } from "./queryKeys";


interface PayoutIssuePreviewProps {
  recipientId: string | null;
  dateRange: string;
  startDate?: string;
  endDate?: string;
}

interface PayoutIssuePreview {
  recipient_id: string;
  amount: number;
  payment_count: number;
  period_start?: string;
  period_end?: string;
}

export const useGetPayoutIssuePreview = ({
  recipientId,
  dateRange,
  startDate,
  endDate,
}: PayoutIssuePreviewProps) =>
  useQuery({
    queryKey: dashboardQKeys.payoutIssuePreview({
      userId: recipientId ?? undefined,
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: async () => {
      const { data } = await api.get<PayoutIssuePreview>("payouts/issue-preview", {
        params: {
          recipient_id: recipientId,
          range: dateRange.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
      return data;
    },
    enabled:
      !!recipientId &&
      (dateRange !== "custom" || !!(startDate && endDate)),
    staleTime: 30_000,
  });
